import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, } from "chart.js";
import { pieArrowLabelsPlugin } from "./pieArrowLabelsPlugin";
import { barRowLabelsPlugin } from "./barRowLabelsPlugin";

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend, pieArrowLabelsPlugin, barRowLabelsPlugin);
